import { type ReportConfig } from '@webapp/modules/reports/config/ReportConfig'
import {
  expenseReportConfig,
  secondaryCategoryReportConfig,
  userReportConfig,
  vendorReportConfig,
} from '@webapp/modules/reports/config/reportConfigs'

const REPORT_CONFIGS: ReportConfig[] = [
  vendorReportConfig,
  userReportConfig,
  secondaryCategoryReportConfig,
  expenseReportConfig,
]

interface ExportHistoryReferrer {
  /** The originating report, or null when the referrer is absent/unknown */
  reportConfig: Nullable<ReportConfig>
  /** Detail-page id when the referrer came from a details view */
  entityId: Nullable<number>
  entityName: Nullable<string>
}

/**
 * Parses the `referrer` query param (`report.type[.id[.name]]` — Angular
 * typeStr parity) into the originating report config plus the optional
 * detail id/name for the `ReportExportHistoryPage` breadcrumbs.
 */
export const parseExportHistoryReferrer = (
  search: string
): ExportHistoryReferrer => {
  const referrer = new URLSearchParams(search).get('referrer')

  if (!referrer) {
    return { reportConfig: null, entityId: null, entityName: null }
  }

  const parts = referrer.split('.')
  const referrerType = parts.slice(0, 2).join('.')

  const reportConfig =
    REPORT_CONFIGS.find((config) => config.referrerType === referrerType) ??
    null

  const parsedId = parts[2] ? Number(parts[2]) : NaN
  const entityId = Number.isInteger(parsedId) && parsedId > 0 ? parsedId : null
  // Entity names may themselves contain dots — rejoin the remainder.
  const entityName = entityId ? parts.slice(3).join('.') || null : null

  return { reportConfig, entityId, entityName }
}
